import { mixinActions, mixinMutations, mixinState } from '../../mixins/vuexCRUD'

const getters = {
  driverHos: (state) => state.items,
}

const state = {
  ...mixinState(),
  path: '/driverHos',
}

const mutations = mixinMutations()

const actions = mixinActions()

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
